import { ROUTES } from '@/constants/routes/default';
import Link from 'next/link';

const NotFoundKG = ({ text }: { text?: string }) => (
  <div className="min-h-[calc(100vh-302px)] flex items-center max-md:py-10 md:py-20">
    <div className="container px-4 w-full flex flex-col items-center text-center">
      <p className="text-sm font-bold text-kg-mako tracking-wider">
        <span aria-hidden="true">{'>'}</span> ERROR
      </p>
      <h1 className="mt-5 max-md:text-3xl md:text-4xl font-bold text-kg-black-pearl tracking-tighter">
        Error 404
      </h1>
      <p className="text-kg-black-pearl mt-5 font-bold text-lg">
        This page didn&apos;t make the list
      </p>
      <p className="text-kg-mako mt-3">
        {text ??
          'That page doesn’t exist. Head to our home page instead or go search for jobs here'}
      </p>
      <Link
        className="mt-7 block w-fit text-sm text-white font-medium px-6 py-3 rounded-sm no-underline bg-kg-fun-blue hover:bg-kg-deep-sapphire default-transition"
        href={ROUTES.jobs}
      >
        SEARCH ALL JOBS
      </Link>
    </div>
  </div>
);

export default NotFoundKG;
